import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summary-dialog',
  templateUrl: './summary-dialog.component.html',
  styleUrls: ['./summary-dialog.component.scss'],
})
export class SummaryDialogComponent implements OnInit {
  active: boolean;

  constructor() {}

  ngOnInit() {}
  openSummaryDialog() {
    this.active = true;
  }

  closeSummaryDialog() {
    this.active = false;
  }

  eventNinja(event: Event) {
    event.stopPropagation();
  }
}
